import config from "./config.json";
import configLocal from "./config.local.json";

export const getApiBaseUrl = () => {
    if (document.location.hostname === "localhost") {
        return configLocal.apiBaseUrl;
    } else {
        return config.apiBaseUrl;
    }
};

export const getCognitoAuthConfig = () => {
    if (document.location.hostname === "localhost") {
        return configLocal.cognitoConfig;
    } else {
        return config.cognitoConfig;
    }
};
